import { CSSTransition } from 'preact-transitioning';

function KitImage ({isCurrentImage, image, width, height}) {
  return (
    <CSSTransition
      in={isCurrentImage}
      duration={300}
      classNames="fade"
      >
      <div className="single-serviceConsole__kits__wrapper-block-img">
          <img src={image} width={width} height={height}/>
      </div>
    </CSSTransition >
  )
}

export { KitImage } 
